import { render, staticRenderFns } from "./HelpCenterCategoriesCreate.vue?vue&type=template&id=6b731b4e&"
import script from "./HelpCenterCategoriesCreate.vue?vue&type=script&lang=js&"
export * from "./HelpCenterCategoriesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports